declare const APP_STAGE: string;
declare const OVERRIDE_TORTUGA_GRAPHQL_URL_DOMAIN: string;
declare const OVERRIDE_CHAMPAIGN_URL_DOMAIN: string;

function urlWithSubdomain(subdomain: string) {
  const { host } = window.location;
  const splitHost = host.split('.');

  if (splitHost.length === 2) {
    // No subdomain
    return `//${subdomain}.${splitHost.join('.')}`;
  }
  // With subdomain
  splitHost[0] = subdomain;
  return `//${splitHost.join('.')}`;
}

export const wwwUrl = () => urlWithSubdomain('www');
export const previewUrl = () => urlWithSubdomain('preview');
export const appUrl = () => urlWithSubdomain('app');
export const cdnUrl = () => urlWithSubdomain('cdn');
export const proxyUrl = () => {
  switch (APP_STAGE) {
    case 'demo':
      return 'https://peek-achoo-demo.com';
    case 'production':
      return 'https://peek-achoo.com';
    case 'staging':
      return 'https://peek-achoo-staging.com';
    default:
      return 'https://peek-achoo.local';
  }
};
export const clientUrl = () => {
  switch (APP_STAGE) {
    case 'demo':
      return '//client-registry.mutinyhq-demo.com';
    case 'production':
      return '//client-registry.mutinycdn.com';
    case 'staging':
      return '//client-registry.mutinycdn-staging.com';
    default:
      return '//client-registry.mutiny.local';
  }
};
export const userDataUrl = () => {
  switch (APP_STAGE) {
    case 'demo':
      return '//user-data.mutinyhq-demo.com';
    case 'production':
      return '//user-data.mutinycdn.com';
    case 'staging':
      return '//user-data.mutinycdn-staging.com';
    default:
      return '//user-data.mutiny.local';
  }
};
export const urlDomain = () => {
  switch (APP_STAGE) {
    case 'demo':
      return '//mutinyhq-demo.com';
    case 'production':
      return '//mutinyhq.com';
    case 'staging':
      return '//mutinyhq-staging.com';
    default:
      return '//mutiny.local';
  }
};
export const appUrlDomain = () => {
  const searchParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
  if (['development', 'staging'].includes(APP_STAGE) && searchParams.has('mutiny_app_url')) {
    return searchParams.get('mutiny_app_url');
  }

  switch (APP_STAGE) {
    case 'demo':
      return '//app.mutinyhq-demo.com';
    case 'production':
      return '//app.mutinyhq.com';
    case 'staging':
      return '//app.mutinyhq-staging.com';
    default:
      return '//app.mutiny.local';
  }
};

export const champaignUrlDomain = () => {
  switch (APP_STAGE) {
    case 'demo':
      return '//campaigns.mutinyhq-demo.com';
    case 'production':
      return '//campaigns.mutinyhq.com';
    case 'staging':
      return '//campaigns.mutinyhq-staging.com';
    default:
      return OVERRIDE_CHAMPAIGN_URL_DOMAIN ? `//${OVERRIDE_CHAMPAIGN_URL_DOMAIN}` : '//champaign.mutiny.local';
  }
};

export const tortugaGraphQLUrlDomain = () => {
  switch (APP_STAGE) {
    case 'production':
      return '//tortuga-ext.mutinyhq.com';
    case 'demo':
    case 'staging':
      return '//tortuga-ext.mutinyhq-staging.com';
    default:
      return OVERRIDE_TORTUGA_GRAPHQL_URL_DOMAIN
        ? `//${OVERRIDE_TORTUGA_GRAPHQL_URL_DOMAIN}`
        : '//tortuga-ext.mutiny.local';
  }
};
